import * as moment from 'moment'
import {KeycloakService} from "@/services/keycloak.service";
import account from "@/views/settings/account/account";

class TimeSlot {
    constructor(timeSlot) {
        this.index = timeSlot ? timeSlot.index : undefined
        this.hours = timeSlot ? timeSlot.hours : undefined
        this.minutes = timeSlot ? timeSlot.minutes : undefined
        this.displayedHours = timeSlot ? timeSlot.displayedHours : undefined
        this.isActive = timeSlot ? timeSlot.isActive : false
        this.isClosed = timeSlot ? timeSlot.isClosed : false
    }

}

class SelectedTimeSlot {
    constructor() {
        this.entityIndex = undefined
        this.startIndex = undefined
        this.endIndex = undefined
    }

    getTimeSlotCount() {
        if (this.startIndex == undefined) {
            return 0
        }
        if (this.endIndex == undefined) {
            return 1
        }
        return this.endIndex - this.startIndex + 1
    }
}

const TimeSlotUtil = {

    FORMAT_HOURS: 'HH',
    FORMAT_MINUTES: 'mm',

    createTimeSlots(startTime, endTime, timeSlotLengthInMinutes, includeEndTime) {
        const startTimeToModify = moment(startTime)
        var slots = TimeSlotUtil.getTimeSlotAmount(startTime, endTime, timeSlotLengthInMinutes)
        if (includeEndTime)
            slots++
        const timeSlots = []
        var currentTimeSlot = new TimeSlot()
        for (var i = 0; i <= slots; i++) {
            if (i > 0) {
                const time = startTimeToModify.add(timeSlotLengthInMinutes, 'minutes')

                const timeSlot = TimeSlotUtil.createTimeSlot(i, time, currentTimeSlot.hours)
                timeSlots.push(timeSlot)
                currentTimeSlot = timeSlot
            }else{
                const timeSlot = TimeSlotUtil.createTimeSlot(i, startTimeToModify, undefined)
                timeSlots.push(timeSlot)
                currentTimeSlot = timeSlot
            }
        }
        return timeSlots
    },

    createTimeSlot(index, date, currentHours) {
        const timeSlot = this.createTimeSlotByDate(date)
        timeSlot.index = index
        timeSlot.displayedHours = timeSlot.hours == currentHours ? '' : timeSlot.hours

        return timeSlot
    },

    createTimeSlotByDate(date) {
        const timeSlot = new TimeSlot()
        timeSlot.hours = moment(date).format(this.FORMAT_HOURS)
        timeSlot.minutes = moment(date).format(this.FORMAT_MINUTES)

        return new TimeSlot(timeSlot)
    },

    createActiveTimeSlots(arrivalDate, startTime, endTime, entities) {
        const activeTimeSlots = []

        for (let entity of entities) {
            let timeslots = this.createTimeSlots(startTime, endTime, entity.timeSlotLengthInMinutes, false)
            for (let i = 0; i < timeslots.length; i ++) {
                let timeslot = timeslots[i]
                const timeSlotStartTime = moment(arrivalDate).set({ hours: timeslot.hours, minutes: timeslot.minutes, seconds: 0, milliseconds: 0 })
                timeslots[i].isClosed = this.isTimeSlotClosed(arrivalDate,timeSlotStartTime, entity.openingHours) // check if timeslot is closed
            }
            activeTimeSlots.push(timeslots)

        }
        return activeTimeSlots
    },

    getTimeSlotTime(date) {
        const time = date.split(':');
        return moment().set({ hours: time[0], minutes: time[1], seconds: 0, milliseconds: 0 })
    },

    getTimeSlotAmount(startTime, endTime, timeSlotLength) {
        const duration = moment.duration(endTime.diff(startTime))
        const minutes = duration.asMinutes()
        //Ceil the value because we can have and endTime of 23:59:00
        return Math.ceil(minutes/timeSlotLength)
    },

    createSelectedTimeSlot(entityIndex, bookings, bookingEntity, timeSlots, arrivalDate) {
        const selectedTimeSlot = new SelectedTimeSlot()
        const startTimeSlot = this.createTimeSlotByDate(bookingEntity.startDate)
        const endTimeSlot = this.createTimeSlotByDate(bookingEntity.endDate)

        const startIndex = this.getMatchingTimeSlotIndex(startTimeSlot, timeSlots)
        const endIndex = this.getMatchingTimeSlotIndex(endTimeSlot, timeSlots, startIndex) - 1

        for (var i = startIndex; i <= endIndex; i++) {
            if (this.isTimeSlotBooked(bookings, timeSlots[i], arrivalDate)) {
                break
            }
            if (selectedTimeSlot.startIndex == undefined) {
                selectedTimeSlot.startIndex = i
            }
            selectedTimeSlot.endIndex = i
        }

        selectedTimeSlot.entityIndex = entityIndex
        return selectedTimeSlot
    },

    getMatchingTimeSlotIndex(timeSlot, availableTimeSlots, fromStartIndex = 0) {
        const slots = availableTimeSlots.filter(slot => slot.hours == timeSlot.hours && slot.minutes == timeSlot.minutes)
        //slots may contain 2 results when availableTimeSlots contains a full day starting at 00:00 and ending at 00:00
        const slotFromIndex = slots.find(slot => slot.index >= fromStartIndex)
        if (slotFromIndex != undefined) {
            return slotFromIndex.index
        }
    },

    isTimeSlotBooked(bookings, timeSlot, arrivalDate, status, accountCustomers) {
        const booking = this.getTimeSlotBooking(bookings, timeSlot, arrivalDate)
        if (booking != undefined) {
            if (KeycloakService.isBookingAgent() && accountCustomers != undefined ) {
                let value = status == undefined ? true : (booking.status.name == status && accountCustomers.map(a => a.id).includes(booking.customer?.id))
                return value
            } else {
                return status == undefined ? true : (booking.status.name == status && booking.customer)
            }
        }
        return false
    },

    isTimeslotPrivate (bookings, timeSlot, arrivalDate, shouldBePrivate, account) {
        const booking = this.getTimeSlotBooking(bookings, timeSlot, arrivalDate)
        if (booking != undefined && KeycloakService.isBookingAgent() && shouldBePrivate) {
            return booking.userCreated !== account.emailAddress
        }
        return false
    },

    /**
     * Function that checks whether the timeslot is closed either by the default week or by the exceptions
     * @return {boolean}
     */
    isTimeSlotClosed(arrivalDate, timeslotStartTime, openingHours) {
        // moment.js starts their week at sunday with index 0 while we start our week on monday hence we need to map the indexes
        let dayMapping = [6, 0, 1, 2, 3, 4, 5]
        const defaultWeek = openingHours.defaultWeek // get openinghours
        const exceptions = openingHours.exceptions // get exceptions

        console.log(openingHours.exceptions)

        // check if this day has an exception
        if (exceptions.filter(e => moment(e.date).isSame(arrivalDate, 'date')).length != 0) {
            let exception = exceptions.filter(e => moment(e.date).isSame(arrivalDate, 'date'))[0] // get the specific exception
            for (let i = 0; i < exception.times.length; i++) { // for every range
                let range = exception.times[i]
                // set ending slot
                if (range.to.toString() == "00:00") {
                    range.to = "23.59"
                }
                let rangeStartTime = TimeSlotUtil.getTimeSlotTime(range.from) // range opening hours
                let rangeEndTime = TimeSlotUtil.getTimeSlotTime(range.to) // range closing hours
                rangeStartTime = moment(arrivalDate).set({
                    hours: rangeStartTime.hours(),
                    minutes: rangeStartTime.minutes(),
                    seconds: 0,
                    milliseconds: 0
                })
                rangeEndTime = moment(arrivalDate).set({
                    hours: rangeEndTime.hours(),
                    minutes: rangeEndTime.minutes(),
                    seconds: 0,
                    milliseconds: 0
                })

                // check if in openinghours
                if (timeslotStartTime.isSameOrAfter(rangeStartTime) && timeslotStartTime.isBefore(rangeEndTime)) {
                    return false
                }
            }

        } else { // no exception
            let day = dayMapping[timeslotStartTime.day()]
            for (let i = 0; i < defaultWeek[day].times.length; i++) {
                let range = defaultWeek[day].times[i]
                if (range.to.toString() == "00:00") {
                    range.to = "23.59"
                }
                let rangeStartTime = TimeSlotUtil.getTimeSlotTime(range.from) // range opening hours
                let rangeEndTime = TimeSlotUtil.getTimeSlotTime(range.to) // range closing hours
                rangeStartTime = moment(arrivalDate).set({ hours: rangeStartTime.hours(), minutes: rangeStartTime.minutes(), seconds: 0, milliseconds: 0 })
                rangeEndTime = moment(arrivalDate).set({ hours: rangeEndTime.hours(), minutes: rangeEndTime.minutes(), seconds: 0, milliseconds: 0 })

                // check if in openinghours
                if (timeslotStartTime.isSameOrAfter(rangeStartTime) && timeslotStartTime.isBefore(rangeEndTime)) {
                    return false
                }
            }
        }



        return true
    },

    getTimeSlotBooking(bookings, timeSlot, arrivalDate) {
        if (bookings != undefined) {
            for (let booking of bookings) {
                const startDate = moment(booking.startDate)
                const endDate = moment(booking.endDate)

                const timeSlotDate = moment(arrivalDate).set({
                    hours: timeSlot.hours,
                    minutes: timeSlot.minutes,
                    seconds: 0,
                    milliseconds: 0
                })
                if (timeSlotDate.isSameOrAfter(startDate) && timeSlotDate.isBefore(endDate)) {
                    return booking
                }
            }
        }
        return undefined
    }
}

export { TimeSlotUtil, TimeSlot, SelectedTimeSlot }
